import PromoLink from "components/promo/link";
Vue.component("PromoLink", PromoLink);
